import styled from 'styled-components';
import { Headline5 } from './../../app/common/typography';

export const LoginContainer = styled.div`
  & .phone-input-dropdown input[disabled],
  & .control-input:has(input[disabled]) {
    background-color: ${({ theme }) => theme.colors.platinum};
  }
`;

export const TextBold = styled(Headline5)`
  display: contents;
`;

export const TextLogged = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
  text-align: center;
`;

export const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.l};
  margin-top: 88px;
`;

export const Title = styled.h1`
  color: black;
  margin: 0;
  font-size: 1.6em;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;

export const Subtitle = styled.h3`
  color: ${({ theme }) => theme.colors.denim};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.xxl};
  margin-top: 20px;
`;

export const LoginForm = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.m};
  padding: 0 ${({ theme }) => theme.spacing.m};
`;

export const FormInputText = styled.input`
  flex: 1;
`;

export const InputContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.m};
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

export const Input = styled.input`
  box-sizing: border-box;
  width: 60px;
  height: 70px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid #919191;
  border-radius: ${({ theme }) => theme.radius.xs};
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.xxxl};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export const CTASection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.xm};
  row-gap: 10px;
  width: 100%;
`;

export const AuthNotificationMessage = styled('span')`
  color: red;
  font-size: ${({ theme }) => theme.fontSize.s};
`;

export const HaveACodeParagraph = styled.p`
  text-align: center;
  line-height: 22px;
  font-size: ${({ theme }) => theme.fontSize.m};
  margin: 0;
  color: ${({ theme }) => theme.colors.eerieBlack};
`;

export const Overlay = styled.div`
  height: 343px;
  width: 333px;
  margin: ${({ theme }) => theme.spacing.xs};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.white};
  padding-top: ${({ theme }) => theme.spacing.xxl};
  padding-bottom: ${({ theme }) => theme.spacing.xxl};
  text-align: center;
`;

export const ForgotPasswordHeader = styled.div`
  text-align: center;
  line-height: 22px;
  font-size: ${({ theme }) => theme.fontSize.m};
  margin: 0;
  color: ${({ theme }) => theme.colors.eerieBlack};
`;

export const RegisterContainer = styled.a`
  text-align: center;
  text-decoration: underline;
`;

export const TermsOfServicesWRapper = styled.div`
  margin-top: auto;
`;

export const ButtonContainer = styled.div`
  display: grid;
  margin: 0 10px;
`;

export const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  background: ${({ theme }) => theme.colors.white};
  padding: 2.5rem 2rem 8rem;
  height: 100%;
  box-sizing: border-box;
`;

export const TitleProfile = styled.h1`
  color: ${({ theme }) => theme.colors.darkBlue};
  margin: 0;
  font-size: 2rem;
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  text-align: left;
`;

export const ProfileForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: ${({ theme }) => theme.spacing.m};
`;

export const ProfileTopSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProfileBottomSection = styled.div`
  display: flex;
  justify-content: center;
`;

export const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FieldRowLabel = styled.div`
  color: ${({ theme }) => theme.colors.darkBlue};
`;

export const FieldRowText = styled.div``;
